import { atom } from "recoil";

export const initialProductManagementState = {
  merchMainCategoryId: 0,
  merchSubCategoryId: 0,
  title: "",
  writer: "",
  price: 0,
  isPreviewEnabled: false,
  isFreeTrial: false,
  isComingSoon: false,
  isMembershipOnly: false,
  isNonSale: false,
  intro: "",
  content: "",
  thumbnailOriginFileName: "",
  thumbnailServerFileName: "",
  bannerOriginFileName: "",
  bannerServerFileName: "",
  relatedMerchUse: false,
  relatedMerchIdList: [],
  relatedMerchList: [],
  openAlarmUse: false,
  merchType: "SHOP",
  merchContentType: "BOOK",
};

export const productManagementState = atom({
  key: "productManagementState",
  default: initialProductManagementState,
});

export const productIsUploadState = atom({
  key: "productIsUploadState",
  default: true,
});
